import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import { FleetDetail } from '../../../features/fleet'

// F2 + F3 — fleet detail page (members, profile editor, divergence).
export default function FleetDetailPage() {
  const { fleetId } = useParams<{ fleetId: string }>()
  const navigate = useNavigate()

  const handleGoBack = () => {
    if (window.history.length > 1) navigate(-1)
    else navigate('/main/setting/fleets', { replace: false })
  }

  return (
    <div>
      <HeaderTitleContent
        withGoBackBtn
        goBackBtnLabel="Retour"
        onGoBack={handleGoBack}
      >
        Parc de luminaires
      </HeaderTitleContent>
      <div style={{ padding: '1rem 0' }}>
        {fleetId && <FleetDetail fleetId={fleetId} />}
      </div>
    </div>
  )
}
